import { environment } from '../../environments/environment';
export class Confrontation {

    // Empty array for active routes
    static ARRAY_EMPTYCLASSES = ["", "", "", "", ""];

    // Setup base url
    static BASE_URL: string = environment.baseUrl;
    static API_VERSIONING: string = "api/";

    // All projects statuses
    static PLANNING: string = "Planning";
    static DEFINING_REQUIREMENTS: string = "Defining Requirements";
    static DESIGNING: string = "Designing";
    static DEVELOPING: string = "Developing";
    static TESTING: string = "Testing";
    static DEPLOYED: string = "Deployed";

    // Filter pipe keys
    static FILTER_TYPE_ONE: string = "class";
    static FILTER_TYPE_TWO: string = "lng";

    // Project status classes
    static STATUS_PLANNING: string = "label-planing";
    static STATUS_DEFINING_REQUIREMENTS: string = "label-defining-requirements";
    static STATUS_DESIGNING: string = "label-designing";
    static STATUS_DEVELOPING: string = "label-developing";
    static STATUS_TESTING: string = "label-testing";
    static STATUS_DEPLOYED: string = "label-deployed";

    // Language keys
    static EN: string = "en";
    static SW: string = "se";
    static VIEW_EN: string = "EN";
    static VIEW_SW: string = "SW";
    static FLAG_EN: string = "../assets/flags/16/United-States.png";
    static FLAG_SW: string = "../assets/flags/16/Sweden.png";

    // Cache keys
    static LANG: string = "lang";

    // ng class names
    static ACTIVE: string = "active";
    static IN: string = "in";

    // request methods
    static GET: string = "get";
    static PUT: string = "put";
    static POST: string = "post";
    static DELETE: string = "delete";

    // Token key
    static TOKEN: string = "token";
    static EXPIRE_DAYS: number = 1;
    static RESULT_DATA: string = "data";
    static USERNAME: string = "g+wt9M1yinEiNvwC1flITDMaRTiHvFz3GhLJ6VOk7Z0=";

    // Default route
    static DEFAULTROUTE: string = "";

    // All routes - shared
    static SERVERERROR: string = "internal_server_error";

    // All routes - dashboard
    static DASHBOARD: string = "dashboard";

    // All routes - projects
    static PROJECTS: string = "projects";
    static SPRINT: string = "sprint";
    static PROJECTDETAILS: string = "project_detail";

    // All routes - issues
    static ISSUES: string = "issues";
    static ISSUE: string = "issue";
    static PROJECTISSUES: string = "project_issues";

    // All routes - test-cases
    static TESTCASES: string = "test_cases";
    static MYTESTCASES: string = "my_test_cases";

    // Auth api
    static API_AUTHENTICATE: string = Confrontation.BASE_URL + Confrontation.API_VERSIONING + "auth/login";

    // Pojects api
    static API_PROJECTS: string = Confrontation.BASE_URL + Confrontation.API_VERSIONING + "user/projects";
    static API_SEARCH_PROJECTS: string = Confrontation.BASE_URL + Confrontation.API_VERSIONING + "user/projects/search";
    static API_SPRINTS: string = Confrontation.BASE_URL + Confrontation.API_VERSIONING + "user/projects/sprints";
    static API_GET_PROJECT_VERSION: string = Confrontation.BASE_URL + Confrontation.API_VERSIONING + "projects/";
    static API_GET_PROJECT_COMPONENTS: string = Confrontation.BASE_URL + Confrontation.API_VERSIONING + "components";

}


// WEBPACK FOOTER //
// ./src/app/shared/confrontation.ts